// extracted by mini-css-extract-plugin
module.exports = {"navigation":"styles_navigation__b3eL_","naviRightSide":"styles_naviRightSide__Qgwve","back":"styles_back__1saZ2"};